import { render, staticRenderFns } from "./AdjustmentsEditor.vue?vue&type=template&id=3c5947de&scoped=true&"
import script from "./AdjustmentsEditor.vue?vue&type=script&lang=js&"
export * from "./AdjustmentsEditor.vue?vue&type=script&lang=js&"
import style0 from "./AdjustmentsEditor.vue?vue&type=style&index=0&id=3c5947de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5947de",
  null
  
)

export default component.exports